import request from '@/utils/request'
const BASE_URL = '/pdd/malladdresses'

export default {
  getSender() {
    return request({
      url: BASE_URL + '/sender',
      method: 'get'
    })
  },
  postSender(data) {
    return request({
      url: BASE_URL + '/sender',
      method: 'post',
      data
    })
  },
  putSender(data) {
    return request({
      url: BASE_URL + '/sender',
      method: 'put',
      data
    })
  },
  delSender(data) {
    return request({
      url: BASE_URL + '/sender',
      method: 'delete',
      data
    })
  },
}